import type React from 'react';
import {
  UiModal,
  UiModalOverlay,
  UiModalContent,
  UiModalHeader,
  UiModalCloseButton,
  UiModalBody,
  UiModalFooter,
  UiButton,
  UiHStack,
  UiText,
  UiBox
} from '@/lib/ui';

interface PaymentLinkModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isLoading: boolean
}

export const PaymentLinkModal: React.FC<PaymentLinkModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading
}) => {
  return (
    <UiModal size="md" isOpen={isOpen} onClose={onClose} isCentered>
      <UiModalOverlay />
      <UiModalContent>
        <UiModalHeader>Generate payment link</UiModalHeader>
        <UiModalCloseButton />
        <UiModalBody>
          <UiBox bgColor="yellow.50" borderRadius={4} p={4} borderWidth={1} borderColor="yellow.200">
            <UiText>
              Please note that when an attendee opens this link, the order will be converted to a credit card order. This means you will no longer be able to track it in reporting as an invoice order.
            </UiText>
          </UiBox>
        </UiModalBody>
        <UiModalFooter>
          <UiHStack spacing={4}>
            <UiButton variant="ghost" onClick={onClose} isDisabled={isLoading}>
              Cancel
            </UiButton>
            <UiButton
              colorScheme="primary"
              onClick={onConfirm}
              isLoading={isLoading}
            >
              Copy link
            </UiButton>
          </UiHStack>
        </UiModalFooter>
      </UiModalContent>
    </UiModal>
  );
};
